export default [
    {
        path: "/admin/inventory/inventory-pending-lists",
        name: "inventory-pending-list",
        meta: { requiresAuth: true },
        component: () => import("@/pages/inventory/inventory-pending-list/index.vue")
    }
];
